export const enum MessageType {
	READY = 'READY',
	REQUEST_TOKENS = 'REQUEST_TOKENS',
	DONE = 'DONE',
	CLOSE = 'CLOSE',
	RESIZE = 'RESIZE',
	AUTH_TOKENS = 'AUTH_TOKENS',
}

export const enum DoneReason {
	COMPLETED = 'completed',
	CANCELLED = 'cancelled',
}

export const LEGACY_DATASETS_TOOLTIP = 'Please create the metric using datasets.';

// One-time popups announcing the deletion of migrated legacy metrics (see services/metric-mover.ts).
export const enum LegacyMetricPopupType {
	SPREADSHEET_SQL = 'spreadsheet_sql',
	PUSH_API = 'push_api',
}

// Metric mover's "Review migrated metrics" page, which the popup's "Review metrics" button
// opens (with a `spaceId` query param).
export const LEGACY_METRIC_REVIEW_PATH = '/review';

// Help article the Push API popup links from "in-app migration tool"; the migration email links the same one.
export const LEGACY_METRIC_MIGRATION_HELP_URL =
	'https://help.databox.com/migrate-legacy-metrics-with-the-migration-tool';
